import React from "react";
import SectionHeader from "./SectionHeader";
import InputField from "./../common/InputField";

function ConfirmationSection() {
  return (
    <section className="mt-6 w-full max-md:max-w-full">
      <SectionHeader icon="key" title="Confirmation" />
      <div className="mt-4 w-full text-sm max-md:max-w-full">
        <InputField
          label="Current Password"
          placeholder="Current Password"
          type="password"
          required
          showPasswordToggle
          helperText="Please enter your current password here to prevent misuse."
          className="w-full leading-loose max-md:max-w-full"
        />
      </div>
    </section>
  );
}

export default ConfirmationSection;
